import * as React from 'react';
import { ICollapsable } from '../../../../../services/quote/models';

interface IAdmiralCardV2Props {
  children?: JSX.Element | JSX.Element[],
  title?: string,
  icon?: string,
  headerMessage?: { showAfterTouched?: boolean, onOpen?: string | JSX.Element, onClosed?: string | JSX.Element }, // extra text under the title
  showHeaderWhenOpen?: boolean, // false -> hides the header when the body is open
  collapsable?: { value?: ICollapsable, onHandleChange?: () => void },
  styleCard?: React.CSSProperties,
  styleBody?: React.CSSProperties,
  scrollIntoView?: { afterTouched?: boolean, afterOpened?: boolean },
}

export const AdmiralCardV2 = ({
                                children,
                                title,
                                icon,
                                headerMessage,
                                showHeaderWhenOpen = true,
                                collapsable,
                                styleCard,
                                styleBody,
                                scrollIntoView,
                              }: IAdmiralCardV2Props) => {

  const ref = React.useRef(null);
  const [isTouched, setTouched] = React.useState(false);
  const [wasOpened, setOpened] = React.useState(false); // stores the previous state of isOpen, to handle events when it is opened
  const isOpen = !!collapsable?.value?.opened || !collapsable;
  const isEditable = !!collapsable?.value?.isEditable;

  const scrollToView = () => {
    setTimeout(() => {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }, 300);
  }

  // isTouched changed
  if (!isTouched && (isEditable || isOpen)) {
    setTouched(true); // isTouched will only be true in the next render cycle
    if (scrollIntoView?.afterTouched && !scrollIntoView?.afterOpened) { // !afterOpened: don't scroll 2x if both set
      scrollToView();
    }
  }

  // isOpen changed
  if ((!wasOpened && isOpen) || (wasOpened && !isOpen)) {
    setOpened(isOpen);
    if (isOpen && scrollIntoView?.afterOpened) {
      scrollToView();
    }
  }

  const handleChangeButton = () => {
    if (collapsable?.onHandleChange) collapsable.onHandleChange();
  };

  const showIcon = () => (icon && (
    <div className={isEditable ? 'adm-icon-circle green' : 'adm-icon-circle'}>
      <img src={require(`../../../img/${icon}`)} alt={''}/>
    </div>
  ));

  const renderHeader = () => {
    return (!isOpen || showHeaderWhenOpen) && (title || icon) && (<>
      <div className={'adm-card-section-header'}>

        {/* HEADER TITLE ROW */}
        <div className={'header-title-row'}>
          {/* ICON */}
          {showIcon()}
          {/* TITLE */}
          <h3>{title}</h3>
          {/* CHANGE BUTTON */}
          {!isOpen && isEditable && (
            <div className={'change-button'} onClick={handleChangeButton}>
              CHANGE
              <img src={require('../../../img/edit.svg')} alt={'edit'}/>
            </div>
          )}
        </div>

        {/* HEADER MESSAGE */}
        {(!headerMessage?.showAfterTouched || (headerMessage?.showAfterTouched && isTouched)) // always show OR only after touched
          && (
            (isOpen && headerMessage?.onOpen && (<div className={'header-message'}>{headerMessage.onOpen}</div>)) ||    // do not show tags if message not available
            (!isOpen && headerMessage?.onClosed && (<div className={'header-message'}>{headerMessage.onClosed}</div>))  // do not show tags if message not available
          )}

      </div>
    </>);
  }

  // ######################### MAIN #########################

  return (
    <div className={'adm-card-v2'} style={styleCard} ref={ref}>

      {/*HEADER*/}
      {renderHeader()}

      {/* BODY */}
      {isOpen && (
        <div className={'adm-card-section-body'} style={styleBody}>
          {children}
        </div>
      )}

    </div>
  )
}
